<div [ngClass]="{'col-12' : renderMode !== 'quickSettings'}">
  @if (aFormControl || !schema?.[SchemaKeywords.UiHide]) {
    @switch (schema | handleSchemaType) {
      @case ('object') {
        <ng-template
          *ngTemplateOutlet="
            objectTemplate;
            context: {
              $implicit: {
                aFormGroup: aFormControl?.get(control),
                schema: (schema | resolveObjectSchema)?.properties,
                additionalPropertiesSchema: schema?.additionalProperties,
                controlName: control,
                depth: 0
              }
            }
            "
        ></ng-template>
      }

      @case ('array') {
        <ng-template
          *ngTemplateOutlet="
            arrayTemplate;
            context: {
              $implicit: {
                aFormArray: aFormControl?.get(control),
                schema: schema,
                controlName: control,
                title: schema?.['title'],
                description: schema?.['description']
              }
            }
          "
        ></ng-template>
      }

      @default {
        <ng-template
          *ngTemplateOutlet="
            primitiveTemplate;
            context: {
              $implicit: {
                aFormControl: aFormControl?.get(control),
                schema: schema,
                controlName: control
              }
            }
            "
        ></ng-template>
      }
    }
  }
</div>

<!-- Object Template -->
<ng-template #objectTemplate let-context>
  <!-- Loop 1: Render defined properties from context.schema -->
  @for (prop of (context.schema | unsortedKeyvalue); track prop.key) {
    @if (prop.value[SchemaKeywords.UiWidget] === SfoUiWidgetType.DateVariableInput) {
      <sfo-date-variable-input
        [aFormControl]="$any(context.aFormGroup?.get(prop.key))"
        [schema]="prop.value"
        [defaultValue]="context?.default?.[prop.key]"
      ></sfo-date-variable-input>
    } @else {
      @switch (prop.value | handleSchemaType) {
        @case ('object') {
          <div class="mt2 col-12">
            <!-- Quick Settings -->
            @if (renderMode === 'quickSettings') {
              <ng-template
                *ngTemplateOutlet="dynamicFieldForDefinedObject; context: {$implicit: prop}"
              ></ng-template>
            }
            <!-- Settings View -->
            @if (renderMode !== 'quickSettings') {
              <!-- If root property of object -->
              @if (context.depth === 0) {
                <!-- Check if the properties has more than one property -->
                @if (prop.value.properties | hasMultipleKeys) {
                  <!-- First level node with more than one property - construct panel -->
                  <div class="pb2">
                    <mat-expansion-panel class="mat-elevation-z0" togglePosition="after">
                      <mat-expansion-panel-header class="mat-panel-header">
                        <mat-panel-title class="mat-panel-title">
                          {{prop?.value?.title ?? prop?.key | titlecase}}
                        </mat-panel-title>

                        @if (prop.value.description) {
                          <mat-panel-description
                            class="mat-panel-description"
                            [matTooltip]="prop.value.description"
                          >
                            {{ prop.value.description }}
                          </mat-panel-description>
                        }
                      </mat-expansion-panel-header>

                      <div class="pt2 mat-panel-body">
                        <ng-template
                          *ngTemplateOutlet="dynamicFieldForDefinedObject; context: {$implicit: prop}"
                        ></ng-template>
                      </div>
                    </mat-expansion-panel>
                  </div>
                } @else {
                  <!-- Content to show if there's no panel, or simply nothing -->
                  <div class="m0">
                    <h2 class="my2 h2">
                      {{prop?.value?.title ?? prop?.key | titlecase}}
                    </h2>
                    <ng-template
                      *ngTemplateOutlet="dynamicFieldForDefinedObject; context: {$implicit: prop}"
                    ></ng-template>
                  </div>
                }
              } @else {
                <mat-expansion-panel class="mat-elevation-z0" togglePosition="after">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{prop?.value?.title ?? prop?.key | titlecase}}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{ prop.value.description }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <ng-template
                    *ngTemplateOutlet="dynamicFieldForDefinedObject; context: {$implicit: prop}"
                  ></ng-template>
                </mat-expansion-panel>
              }
            }
            <ng-template #dynamicFieldForDefinedObject let-propContext="$implicit">
              <ng-template
                *ngTemplateOutlet="objectTemplate;
              context: {
                $implicit: {
                  aFormGroup: context.aFormGroup?.get(propContext.key),
                  schema: (propContext.value | resolveObjectSchema)?.['properties'],
                  additionalPropertiesSchema: propContext.value?.['additionalProperties'],
                  depth: context.depth + 1,
                  default: context?.default?.[propContext.key] || context?.default || '',
                  controlName: propContext.key
                },
              }"
              ></ng-template>
            </ng-template>
          </div>
        }

        @case ('array') {
          @if (context.depth === 0 && renderMode !== 'quickSettings') {
            <div class="mt2 col-12">
              <mat-expansion-panel class="mat-elevation-z0" togglePosition="after">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ prop?.value?.title || prop?.key | titlecase }}
                  </mat-panel-title>

                  @if (prop.value.description) {
                    <mat-panel-description
                      class="mat-panel-description"
                      [matTooltip]="prop.value.description"
                    >
                      {{ prop.value.description }}
                    </mat-panel-description>
                  }
                </mat-expansion-panel-header>
                <ng-template
                  *ngTemplateOutlet="dynamicFieldForDefinedArray; context: {$implicit: prop}"
                ></ng-template>
              </mat-expansion-panel>
            </div>
          } @else {
            <ng-template
              *ngTemplateOutlet="dynamicFieldForDefinedArray; context: {$implicit: prop}"
            ></ng-template>
          }
          <ng-template #dynamicFieldForDefinedArray let-propContext="$implicit">
            <ng-template
              *ngTemplateOutlet="arrayTemplate;
            context: {
              $implicit: {
                aFormArray: context.aFormGroup?.get(propContext.key),
                schema: propContext.value,
                controlName: propContext.key,
                title: propContext.value?.['title'],
                description: propContext.value?.['description']
              }
            }"
            ></ng-template>
          </ng-template>
        }

        @default {
          <ng-template
            *ngTemplateOutlet="
              primitiveTemplate;
              context: {
                $implicit: {
                  aFormControl: context.aFormGroup?.get(prop.key),
                  schema: prop.value,
                  controlName: prop.key,
                  view: context.view || '',
                  default: context?.default?.[prop.key]
                }
              }
            "
          ></ng-template>
        }
      }
    }
  }

  <!-- Loop 2: Render additional (custom) properties that are in the form group but not in context.schema -->
  @if (context.additionalPropertiesSchema | objectNotEmpty) {
    @for (
      controlKey of (getAdditionalPropertyKeys(context.aFormGroup, context.schema));
      track controlKey
    ) {
      <!-- currentCustomSchema is context.additionalPropertiesSchema -->
      @switch (context.additionalPropertiesSchema.type) {
        @case ('object') {
          <div class="mt2 col-12">
            <mat-expansion-panel class="mat-elevation-z0" togglePosition="after">
              <mat-expansion-panel-header class="mat-panel-header">
                <mat-panel-title class="mat-panel-title">
                  {{ controlKey }}
                  @if (context.additionalPropertiesSchema.title) {
                    <span class="text-muted small ml1"
                      >({{ context.additionalPropertiesSchema.title }})</span
                    >
                  }
                </mat-panel-title>
                @if (context.additionalPropertiesSchema.description) {
                  <mat-panel-description
                    [matTooltip]="context.additionalPropertiesSchema.description"
                  >
                    {{ context.additionalPropertiesSchema.description }}
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="pt2 mat-panel-body">
                <ng-template
                  *ngTemplateOutlet="objectTemplate;
                  context: {
                    $implicit: {
                      aFormGroup: context.aFormGroup?.get(controlKey),
                      schema: context.additionalPropertiesSchema.properties,
                      additionalPropertiesSchema: context.additionalPropertiesSchema.additionalProperties,
                      depth: context.depth + 1,
                      controlName: controlKey
                    }
                  }"
                ></ng-template>
              </div>

              <div class="flex justify-end mt2">
                <button
                  type="button"
                  mat-icon-button
                  (click)="removeCustomProperty(context.aFormGroup, controlKey, context.controlName)"
                  [matTooltip]="'Delete: ' + controlKey"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-expansion-panel>
          </div>
        }
        @case ('array') {
          <div class="mt2 col-12">
            <mat-expansion-panel class="mat-elevation-z0" togglePosition="after">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ context.additionalPropertiesSchema?.title || controlKey }}
                </mat-panel-title>
                @if (context.additionalPropertiesSchema.description) {
                  <mat-panel-description
                    [matTooltip]="context.additionalPropertiesSchema.description"
                  >
                    {{ context.additionalPropertiesSchema.description }}
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <ng-template
                *ngTemplateOutlet="arrayTemplate;
                context: {
                  $implicit: {
                    aFormArray: context.aFormGroup?.get(controlKey),
                    schema: context.additionalPropertiesSchema,
                    controlName: controlKey,
                    title: context.additionalPropertiesSchema?.title || controlKey,
                    description: context.additionalPropertiesSchema?.description
                  }
                }"
              ></ng-template>
            </mat-expansion-panel>
          </div>
        }
        @default {
          <!-- Primitive custom property -->
          <div class="col-12 py1">
            <ng-template
              *ngTemplateOutlet="primitiveTemplate;
                context: {
                  $implicit: {
                    aFormControl: context.aFormGroup?.get(controlKey),
                    schema: context.additionalPropertiesSchema,
                    controlName: controlKey,
                    default: context?.default?.[controlKey]
                  }
                }"
            ></ng-template>
          </div>
        }
      }
    }

    <div class="col-12 mt2 mb2 pt2 border-top">
      <button
        type="button"
        matButton="outlined"
        (click)="promptAndAddCustomProperty(context.aFormGroup, context.additionalPropertiesSchema, context.controlName)"
      >
        <mat-icon>add_circle_outline</mat-icon>
        Add Custom Property
      </button>
    </div>
  }
</ng-template>

<!-- Array Template -->
<ng-template #arrayTemplate let-context>
  @if (context?.schema?.[SchemaKeywords.UiWidget] === SfoUiWidgetType.EnumInput) {
    <div [ngClass]="context.schema[SchemaKeywords.UiClass] || 'col-12 py1'">
      <sfo-enum-input
        [aFormControl]="context.aFormArray"
        [schema]="context.schema"
        [defaultValue]="context.default"
        [title]="context.title"
      ></sfo-enum-input>
    </div>
  } @else if (context?.schema?.[SchemaKeywords.UiWidget] === SfoUiWidgetType.CreatorRoleArray) {
    <div [ngClass]="context.schema[SchemaKeywords.UiClass] || 'col-12 py1'">
      <sfo-name-input
        [aFormControl]="context.aFormArray"
        [schema]="context.schema"
        [defaultValue]="context.default"
      ></sfo-name-input>
    </div>
  } @else {
    <div class="col-12 overflow-auto">
      <div class="mb1 flex items-center justify-between">
        <div>
          @if (context.schema?.title) {
            <h2 class="h3 mb0 bold">
              {{context.schema?.title}}
            </h2>
          }
          @if (context.schema?.description) {
            <small class="small">
              {{context.schema?.description}}
            </small>
          }
        </div>
        <div class="flex items-center">
          @if (shouldShowArrayResetButton(context.aFormArray, context.schema)) {
            <button
              type="button"
              mat-icon-button
              matTooltip="Reset to default"
              aria-label="Reset to default"
              class="mr1"
              (click)="resetArrayToDefault(context.aFormArray, context.schema)"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          }
          <button matButton="outlined" (click)="addRow(context.aFormArray, context.schema.items)">
            Add
          </button>
        </div>
      </div>

      @if (context.aFormArray.length === 0) {
        <div class="sf-array-empty">No entries yet — use the “Add” button above to create one.</div>
      }

      @if (context.schema?.items?.type === 'object' && context.schema?.items?.properties) {
        <table class="col-12">
          <thead>
            <tr>
              <th class="col-1"></th>
              @for (prop of context.schema?.items.properties | unsortedKeyvalue; track prop.key) {
                <th [ngClass]="prop.value['_ui_table_width'] || 'col-12'">
                  @if (isTableColumnSortable(prop.value)) {
                    <button
                      type="button"
                      class="table-header-button"
                      (click)="toggleSort(context.aFormArray, prop.key, prop.value)"
                      [attr.aria-label]="'Sort by ' + (prop.value.title || prop.key)"
                    >
                      <span class="bold">{{ prop.value.title || prop.key }}</span>
                      @switch (getSortDirection(context.aFormArray, prop.key)) {
                        @case ('asc') {
                          <mat-icon class="table-sort-icon">arrow_upward</mat-icon>
                        }
                        @case ('desc') {
                          <mat-icon class="table-sort-icon">arrow_downward</mat-icon>
                        }
                        @default {
                          <mat-icon class="table-sort-icon">unfold_more</mat-icon>
                        }
                      }
                    </button>
                  } @else {
                    <span class="bold">{{ prop.value.title || prop.key }}</span>
                  }
                </th>
              }
              <th class="col-1">
                <span class="bold">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody cdkDropList (cdkDropListDropped)="dropRow($event, context.aFormArray)">
            @for (control of context.aFormArray.controls; track control; let i = $index) {
              <tr cdkDrag cdkDragLockAxis="y">
                <td class="col-1 table-drag-cell">
                  <button
                    type="button"
                    mat-icon-button
                    cdkDragHandle
                    [attr.aria-label]="'Reorder row ' + (i + 1)"
                    [matTooltip]="'Reorder'"
                  >
                    <mat-icon>drag_indicator</mat-icon>
                  </button>
                </td>
                @for (prop of context.schema?.items.properties | unsortedKeyvalue; track prop.key) {
                  <td [ngClass]="prop.value['_ui_table_width'] || 'col-12'">
                    @switch (prop.value.type) {
                      @case ('object') {
                        <ng-template
                          *ngTemplateOutlet="
                        objectTemplate;
                        context: {
                          $implicit: {
                            aFormGroup: context.aFormArray.at(i).get(prop.key),
                            schema: prop.value.properties,
                            controlName: prop.key,
                            depth: 0,
                            default: prop.value.default || (context.schema.default?.[i]?.[prop.key] || {})
                          }
                        }
                      "
                        ></ng-template>
                      }

                      @case ('array') {
                        <ng-template
                          *ngTemplateOutlet="
                        arrayTemplate;
                        context: {
                          $implicit: {
                            aFormArray: context.aFormArray.at(i).get(prop.key),
                            schema: prop.value,
                            controlName: prop.key,
                            depth: 0,
                            default: prop.value.default || (context.schema.default?.[i]?.[prop.key] || [])
                          }
                        }
                      "
                        ></ng-template>
                      }

                      @default {
                        <ng-template
                          *ngTemplateOutlet="
                        primitiveTemplate;
                        context: {
                          $implicit: {
                            aFormControl: context.aFormArray.at(i).get(prop.key),
                            schema: prop.value,
                            controlName: prop.key,
                            default: prop.value.default || (context.schema.default?.[i]?.[prop.key] || '')
                          }
                        }
                      "
                        ></ng-template>
                      }
                    }
                  </td>
                }
                <td class="col-1">
                  <div class="flex items-center justify-center table-actions">
                    <button
                      type="button"
                      mat-icon-button
                      (click)="moveRowUp(i, context.aFormArray)"
                      [disabled]="i === 0"
                      [matTooltip]="'Move up'"
                      aria-label="Move row up"
                    >
                      <mat-icon>arrow_upward</mat-icon>
                    </button>
                    <button
                      type="button"
                      mat-icon-button
                      (click)="moveRowDown(i, context.aFormArray)"
                      [disabled]="i === context.aFormArray.length - 1"
                      [matTooltip]="'Move down'"
                      aria-label="Move row down"
                    >
                      <mat-icon>arrow_downward</mat-icon>
                    </button>
                    <button
                      type="button"
                      mat-icon-button
                      (click)="removeRow(i, context.aFormArray)"
                      [matTooltip]="'Delete row'"
                      aria-label="Delete row"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="col-12" cdkDropList (cdkDropListDropped)="dropRow($event, context.aFormArray)">
          @for (control of context.aFormArray.controls; track control; let i = $index) {
            <div class="flex items-center mb2" cdkDrag cdkDragLockAxis="y">
              <div class="mr1">
                <button
                  type="button"
                  mat-icon-button
                  cdkDragHandle
                  [attr.aria-label]="'Reorder item ' + (i + 1)"
                  [matTooltip]="'Reorder'"
                >
                  <mat-icon>drag_indicator</mat-icon>
                </button>
              </div>
              <div class="flex-auto">
                <ng-template
                  *ngTemplateOutlet="
                  primitiveTemplate;
                  context: {
                    $implicit: {
                      aFormControl: context.aFormArray.at(i),
                      schema: context.schema?.items,
                      controlName: i.toString(),
                      default: context.schema?.default?.[i] || ''
                    }
                  }
                "
                ></ng-template>
              </div>
              <div class="ml2 flex items-center">
                <button
                  type="button"
                  mat-icon-button
                  (click)="moveRowUp(i, context.aFormArray)"
                  [disabled]="i === 0"
                  [matTooltip]="'Move up'"
                  aria-label="Move item up"
                >
                  <mat-icon>arrow_upward</mat-icon>
                </button>
                <button
                  type="button"
                  mat-icon-button
                  (click)="moveRowDown(i, context.aFormArray)"
                  [disabled]="i === context.aFormArray.length - 1"
                  [matTooltip]="'Move down'"
                  aria-label="Move item down"
                >
                  <mat-icon>arrow_downward</mat-icon>
                </button>
                <button
                  type="button"
                  mat-icon-button
                  (click)="removeRow(i, context.aFormArray)"
                  [matTooltip]="'Delete item'"
                  aria-label="Delete item"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</ng-template>

<!-- Primitive Template -->
<ng-template #primitiveTemplate let-context>
  @if (context.schema) {
    @if (context.schema?.[SchemaKeywords.UiHide] !== true) {
      <div [ngClass]="context.schema[SchemaKeywords.UiClass] || 'col-12 py1'">
        <sfo-dynamic-input
          [aFormControl]="context.aFormControl"
          [schema]="context.schema"
          [defaultValue]="context.default"
        ></sfo-dynamic-input>
      </div>
    }
  } @else {
    <p class="negative">Failed to create a form field: no schema was provided.</p>
  }
</ng-template>
